module.exports = __webpack_public_path__ + "static/media/temp-w-domu-grzanie.243247a0.svg";